export default "__VITE_ASSET__ef7adcca__"